import { Box } from '@mui/material'
import DashboardLogo from '../../../assets/Images/dashboard-logo.png'
import React from 'react'

export default function index() {
    return (
        <Box  >
            <img style={{ width: "100px" }} alt="" src={DashboardLogo} />
        </Box>
    )

}
